import { useState, useCallback } from 'react';

interface UseInputAmountProps {
  initialValue?: string;
  allowEmpty?: boolean;
  type?: 'buy' | 'sell';
}

export const usePriceChg = ({ initialValue = '0.1', allowEmpty = true, type = 'buy' }: UseInputAmountProps) => {
  const [inputAmount, setInputAmount] = useState(initialValue);

  const validatePriceChange = useCallback(
    (value: string): boolean => {
      // 移除前导零后再验证数值范围
      const numValue = Number(value.replace(/^0+/, '') || '0');

      // 确保是整数
      if (!Number.isInteger(numValue)) {
        return false;
      }

      if (type === 'buy') {
        // Price Drop: 1% - 99%
        return numValue >= 1 && numValue <= 99;
      } else {
        // Price Increase: 1% - 无限
        return numValue >= 1;
      }
    },
    [type],
  );

  const onChangeInputAmount = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;

      // 处理空值
      if (!value) {
        setInputAmount('');
        return;
      }

      // 检查是否只包含数字（允许前导零）
      if (!/^\d+$/.test(value)) {
        return;
      }

      // 验证涨跌幅范围
      if (!validatePriceChange(value)) {
        return;
      }

      setInputAmount(value);
    },
    [validatePriceChange],
  );

  const onBlurInputAmount = useCallback(() => {
    if (!inputAmount && allowEmpty) {
      setInputAmount('0');
      return;
    }

    const defaultValue = '0.1';

    // 如果输入为空或全是0
    if (!allowEmpty && (!inputAmount || /^0+$/.test(inputAmount))) {
      setInputAmount(defaultValue);
      return;
    }

    // 移除前导零，但保留单个0
    const normalizedValue = inputAmount.replace(/^0+/, '') || '0';
    setInputAmount(normalizedValue);
  }, [inputAmount, allowEmpty]);

  return {
    inputAmount,
    setInputAmount,
    onChangeInputAmount,
    onBlurInputAmount,
  };
};
